"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ProductSustainabilityTabCTA = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const cotopaxi_1 = require("@as/cotopaxi");
const ProductSustainabilityTabCTA = ({ url, text }) => ((0, jsx_runtime_1.jsx)(cotopaxi_1.Button, { fill: true, variant: cotopaxi_1.ButtonVariant.SUSTAINABLE, iconRight: { name: cotopaxi_1.IconName.CHEVRON_RIGHT }, href: url, text: text }));
exports.ProductSustainabilityTabCTA = ProductSustainabilityTabCTA;
